import { useEffect, useState } from "react";
import { Layout } from "../../shared/utils/ui/Layout";
import { Typography, Box, Tabs, Tab, IconButton } from "@mui/material";
import {
  ContractProvider,
  useContractContext,
} from "./contexts/ContractContext";
import { useParams } from "react-router-dom";
import Image from "shared/assets/index";
import { useDetailedConsultation } from "./hooks/useDetailedConsultation";
import { RouterGuard, Spinner } from "shared/components";
import { SteppersStates } from "./components/StepperStates";
import { TabPanel } from "./components";
import style from "./styles/detailedConsultation.module.scss";
import { useTableResults } from "shared/hooks/useTableResults";
import { MenuFunctions } from "pages/read-documents/components/MenuFunctions";
import { useDispatch, useSelector } from "react-redux";
import { Dispatch, RootState } from "shared/store/store";
import { TabDetails } from "./components";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import CommentIcon from "@mui/icons-material/Comment";
import { StyledBadge } from "shared/utils";
import { Tooltip } from "@mui/material";
import { GET_ELECTRONIC_DOCS } from "shared/api";
import { SnackBarAlert } from "shared/components/snackBar/SnackBarAlert";
import { getCums, getCups } from "shared/api/services/getCupsCums";
import { activities } from "shared/models/lineStates";
import { accesRoles } from "shared/models";
import { findActivityStatus } from "../read-documents/helper/findActivityStatus";

import { saveSearchHistoryElectronicDocument, selectIndex } from "shared/utils";
import FloatingInfoIcon from "shared/components/floating-info/FloatingInfoIcon";
import { apiInstance } from "shared";

export const DetailedConsultation = () => {
  const { idDocument } = useParams();
  const dispatch = useDispatch<Dispatch>();
  const { anchorOrigin, notifications } = useSelector(
    (state: RootState) => state.notifications,
  );
  const { contractUpdated, resetContractUpdate } = useContractContext();
  const { content } = useSelector(
    (state: RootState) => state.electronicDocuments,
  );
  const { dataGeneralParameters } = useSelector(
    (state: RootState) => state.invoiceData,
  );
  const { sumValuesAllValueNotAccept } = useSelector(
    (state: RootState) => state.consolidateGlosas,
  );
  const { users } = useSelector((state: RootState) => state.optionsDropdowns);
  const { valuesPaymentConsolidate } = useSelector(
    (state: RootState) => state.auditDetails,
  );
  const commentsState = useSelector((state: RootState) => state.comments);
  const [isBillValueNotAccept, setIsBillValueNotAccept] = useState(false);
  const {
    value,
    timeLine,
    contentTabs,
    isLoading,
    handleChange,
    callGetDetailedDocument,
    handleViewPayments,
    detailedParametersServices,
  } = useDetailedConsultation();
  const {
    paramsUrl,
    actionModalAbortDE,
    linkToDian,
    actionModalResetAudit,
    setDataAlert,
    setShowAlert,
    currentPath,
    showAlert,
    dataAlert,
    dataLocalStorage,
  } = useTableResults(callGetDetailedDocument);
  const [document, setDocument] = useState<any | undefined>(undefined);
  const [showAlertPayments, setShowAlertPayments] = useState(false);
  const [dataDuplicates, setDataDuplicates] = useState<any[]>([]);

  // useEffect(() => {
  //   if (document?.state?.code == activities.facturaComprobanteDePagos) {
  //     setShowAlertPayments(true);
  //   }
  //   if ([activities.AsignadaParaAuditoria, activities.facturaGlosasEnviadas].includes(document?.state?.code)) {
  //     apiInstance.get(`${GET_ELECTRONIC_DOCS}/entitlement-payment?electronicDocumentId=${document.id}`).then(({ data }) => {
  //       apiInstance.get(`${GET_ELECTRONIC_DOCS}/potencial-duplicate?electronicDocumentId=${document.id}`).then(({ data: dataDup }) => {
  //         setDataDuplicates([{content: data, type:'success'}, {content: dataDup, type:'warning'}]);
  //       });
  //     });
  //   }
  // }, [document]);
  useEffect(() => {
    if (dataLocalStorage == null && dataGeneralParameters[0]?.content) {
      if (selectIndex(currentPath[0]) === 1) {
        saveSearchHistoryElectronicDocument({
          params: {
            filter: dataGeneralParameters[0]?.content?.nroFactura,
            origin: "MENU",
            states: "",
          },
          url: `${GET_ELECTRONIC_DOCS}/page`,
        });
      }
    }
  }, [dataGeneralParameters, currentPath]);

  useEffect(() => {
    const billNotAccept =
      sumValuesAllValueNotAccept <= 0 &&
      valuesPaymentConsolidate?.initialValues?.consolidatedInNoAgreementValue
        ?.value <= 0;
    setIsBillValueNotAccept(!billNotAccept);
  }, [valuesPaymentConsolidate?.initialValues, sumValuesAllValueNotAccept]);

  useEffect(() => {
    if (content) {
      setDocument(content?.find((doc) => doc.id === Number(idDocument!)));
    } else {
      dispatch.electronicDocuments.getElectronicDocuments(
        { states: "", id: idDocument },
        `${GET_ELECTRONIC_DOCS}/page`,
      );
    }
  }, [content, dispatch.electronicDocuments, idDocument]);

  useEffect(() => {
    callGetDetailedDocument(idDocument || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [anchorOrigin, notifications]);

  useEffect(() => {
    dispatch.menuDrawer.changeSelectedIndex(selectIndex(currentPath[0]));
    dispatch.comments.getCommentListAsync(idDocument ?? "");
    dispatch.iframes.getIframeListAsync();
    users.length === 0 && dispatch.optionsDropdowns.getUsers();

    return () => {
      dispatch.electronicDocuments.cleanState();
      dispatch.consolidateGlosas.cleanState();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      document &&
      document?.state?.code == activities.AsignadaParaAuditoria &&
      dataAlert.length === 1
    ) {
      const fetchCupsAndCums = async () => {
        try {
          const [responseCups, responseCums] = await Promise.all([
            getCups(idDocument ?? ""),
            getCums(idDocument ?? ""),
          ]);
          const newAlerts = [
            ...responseCups.map((item: any) => ({
              typeIcon: "warning",
              message: item.validation,
            })),
            ...responseCums.map((item: any) => ({
              typeIcon: "warning",
              message: item.validation,
            })),
          ];

          setDataAlert((data) => [...newAlerts, ...data]);
        } catch (error) {
          console.error(error);
        }
      };
      fetchCupsAndCums();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [document]);

  // Efecto para escuchar cambios en el contexto (cuando se guarda un contrato)
  useEffect(() => {
    if (contractUpdated) {
      // Recargar los datos detallados para obtener la información actualizada del contrato
      if (idDocument) {
        callGetDetailedDocument(idDocument);
        resetContractUpdate();
      }
    }
  }, [
    contractUpdated,
    idDocument,
    callGetDetailedDocument,
    resetContractUpdate,
  ]);

  return (
    <Layout>
      <div
        className={`${style.trafficLightStyleContent} ${
          style[`${findActivityStatus(document)}T`]
        }`}
      >
        <span></span>
      </div>
      {showAlert && (
        <SnackBarAlert close={() => setShowAlert(false)} data={dataAlert} />
      )}
      {/* {
        dataDuplicates.length > 0 && dataDuplicates.map((data, index) => (
          data.content.length > 0 && (
            <SnackBarAlert 
              key={index}
              close={() => setDataDuplicates(dataDuplicates.filter((_, i) => i !== index))}
              data={[{
                message: data.content,
                typeIcon: data.type,
              }]}
            />
        )
      ))} */}
      {showAlertPayments && (
        <SnackBarAlert
          close={() => setShowAlertPayments(false)}
          data={[
            {
              message:
                "💰 Esta factura tiene información de pago registrada. Haz clic aquí para consultarla.",
              typeIcon: "success",
            },
          ]}
          onNavigate={handleViewPayments}
        />
      )}

      <div className={style.containerMain} data-testid="contenido_principal">
        <div className={style.cardHeaderStepper}>
          <div className={style.headerRow}>
            <div className="containerTitleCardTabs">
              <Typography>
                Detalles factura N°{" "}
                {dataGeneralParameters[0]?.content?.nroFactura}
              </Typography>
            </div>
            <div className={style.headerActivityCard}>
              <span className={style.activityLabel}>Actividad actual:</span>
              <span className={style.activityValue}>
                {document?.state?.name || "Sin estado"}
              </span>
            </div>
          </div>
          <div className={style.stepperCardWrapper}>
            <SteppersStates timeLine={timeLine} />
          </div>
        </div>
        {document && (
          <>
            <div
              className={style.containerActions}
              data-testid="content_document"
            >
              <Box className={style.actions}>
                <img src={Image.iconoEditar} alt="Edit" />
                <MenuFunctions
                  detailed={true}
                  paramsUrl={paramsUrl}
                  doc={document}
                  actionModalAbortDE={actionModalAbortDE}
                  linkToDian={linkToDian}
                  actionModalResetAudit={actionModalResetAudit}
                  isBillValueNotAccept={isBillValueNotAccept}
                />
              </Box>
              <RouterGuard roles={accesRoles.reader} type="component">
                <Tooltip title="Comentarios" placement="top" arrow>
                  <IconButton
                    className={style.commentsButton}
                    disableRipple
                    onClick={() => {
                      dispatch.comments.handleOpenDrawer(true);
                      dispatch.iframes.handleOpenDrawer(false);
                    }}
                    data-testid="open_comments"
                  >
                    <StyledBadge
                      badgeContent={commentsState.comments.length}
                      color="primary"
                    >
                      <CommentIcon />
                    </StyledBadge>
                  </IconButton>
                </Tooltip>
              </RouterGuard>
              <RouterGuard roles={accesRoles.usersSSSA} type="component">
                <Tooltip title="Herramientas" placement="top" arrow>
                  <IconButton
                    className={style.commentsButton}
                    disableRipple
                    onClick={() => {
                      dispatch.iframes.handleOpenDrawer(true);
                      dispatch.comments.handleOpenDrawer(false);
                    }}
                    data-testid="open_iframes"
                  >
                    <HomeRepairServiceIcon />
                  </IconButton>
                </Tooltip>
              </RouterGuard>
            </div>
            <div>
              <TabDetails
                detailedParameters={dataGeneralParameters}
                docState={detailedParametersServices}
              />
            </div>
          </>
        )}
        <Box className={style.contenedorTabs}>
          <Tabs
            value={value}
            onChange={handleChange}
            className={style.contenTabs}
            TabIndicatorProps={{ style: { display: "none" } }}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            TabScrollButtonProps={{ className: style.scrollButton }}
          >
            {contentTabs
              .filter((tab) => !tab.hidden)
              .map((tab: any, index: number) =>
                tab.hidden ? (
                  <Tab key={index} sx={{ display: "none" }} />
                ) : (
                  <Tab
                    key={index}
                    label={tab.label}
                    disabled={tab.disable}
                    defaultValue={tab.label}
                    className={style.contentTab}
                    data-testid={`tab_${index}`}
                    style={
                      value === tab.id
                        ? {
                            backgroundColor:
                              "rgba(var(--general-color-r), var(--general-color-g), var(--general-color-b), 1)",
                            color: "#fff",
                          }
                        : {
                            backgroundColor: "#fff",
                            color:
                              "rgba(var(--general-color-r), var(--general-color-g), var(--general-color-b), 1)",
                          }
                    }
                  />
                ),
              )}
          </Tabs>
        </Box>

        {contentTabs
          .filter((tab) => !tab.hidden)
          .map((tab: any, index: number) => (
            <TabPanel key={index} value={value} index={tab.id}>
              {tab.content}
            </TabPanel>
          ))}
      </div>
      {isLoading && <Spinner />}
    </Layout>
  );
};
